<template>
    <v-container fluid class="sp-container">
        <v-row no-gutters justify="center">
            <v-col cols="10" class="sp-container__content">
                <v-row no-gutters justify="center">
                    <v-col cols="4" class="mb-10 text-center">
                        <v-list-item href="https://roadcube.com" class="d-flex justify-center align-center rounded-lg " style="max-width: 200px;"> <img
                                src="@/assets/home/logo-sticky.png"
                                width="160"
                                style="vertical-align: middle"
                            /></v-list-item>
                    </v-col>
                    <v-col cols="12" class="text-center sp-container__subtitle">
                        Please select your package
                    </v-col>

                    <v-row no-gutters justify="center" class="px-12">
                        <v-col
                            v-for="plan in subscriptionPlans"
                            :key="plan.store_subscription_plan_id"
                            cols="3"
                            class="mx-4"
                        >
                            <v-card class="mt-5 pa-4 sp-container__card">
                                <div
                                    class="
                                        text-center
                                        mt-8
                                        font-weight-bold
                                        card__price-box
                                    "
                                >
                                    <span class="font-weight-bold card__price">
                                        {{ plan.plan_price }}
                                    </span>
                                    €
                                </div>

                                <div
                                    class="
                                        text-center
                                        font-weight-bold
                                        card__subtitle
                                    "
                                >
                                    {{
                                        plan.interval && plan.interval_count
                                            ? plan.interval == "month"
                                                ? plan.interval_count == 1
                                                    ? "/ month"
                                                    : `/ ${plan.interval_count} months`
                                                : plan.interval_count == 1
                                                ? "/ year"
                                                : `/ ${plan.interval_count} years`
                                            : "/ month"
                                    }}
                                </div>

                                <div
                                    class="
                                        font-weight-black
                                        card__description
                                        px-2
                                    "
                                >
                                    <span
                                        v-html="
                                            replaceCharactersToIcons(
                                                plan.plan_description[lang]
                                            )
                                        "
                                    ></span>
                                </div>

                                <v-col>
                                    <v-btn
                                        color="#2255fe"
                                        class="card__btn"
                                        block
                                        @click="
                                            setSubscriptionPlan(
                                                plan.store_subscription_plan_id
                                            )
                                        "
                                        >Start Now</v-btn
                                    >
                                </v-col>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {
    mdiFileDocumentEditOutline,
    mdiCheck,
    mdiCheckboxMarked,
    mdiAlphaXBox,
} from "@mdi/js";
import { mapMutations, mapActions } from "vuex";

export default {
    name: "SubscriptionPlans",

    data: () => ({
        icons: {
            mdiFileDocumentEditOutline,
            mdiCheck,
            mdiCheckboxMarked,
            mdiAlphaXBox,
        },
        registerPage: null,
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        subscriptionPlans() {
            return this.$store.state.register.subscriptionPlans;
        },
    },

    methods: {
        ...mapMutations("register", ["setAppProvider"]),
        ...mapActions("register", ["getSubscriptionPlans"]),

        setSubscriptionPlan(planId) {
            localStorage.setItem("subscriptionPlan", planId);
            if (this.registerPage == 1) {
                this.$router.push(`/${this.lang}/create-company`);
            } else {
                this.$router.push(`/${this.lang}/create-store`);
            }
        },

        replaceCharactersToIcons(text) {
            text = text.replaceAll(
                "-",
                `<br /><br /><span aria-hidden="true" class="v-icon notranslate red-text v-icon--svg theme--light"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24" role="img" aria-hidden="true"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path></svg></span>`
            );
            text = text.replaceAll(
                "+",
                `<br /><br /><span aria-hidden="true" class="v-icon notranslate green-text v-icon--svg theme--light"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><path fill="#43A047" d="M40.6 12.1L17 35.7 7.4 26.1 4.6 29 17 41.3 43.4 14.9z"></path></svg></span>`
            );
            return text;
        },
    },

    mounted() {
        let accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
            localStorage.setItem("redirectUrl", "subscription-plans");
                console.log('plans')
            this.$router.push(`/${this.lang}/create-account`);
        }

        const app_provider_id = localStorage.getItem("appProvider");
        const store_id = localStorage.getItem("providerStoreId");
        this.setAppProvider({ app_provider_id, store_id });
        this.registerPage = 1;
        if (this.$route.query.plan) {
            const body = {
                registerPage: this.registerPage,
                plan: this.$route.query.plan,
            };
            this.getSubscriptionPlans(body);
        } else {
            const body = {
                registerPage: this.registerPage,
                plan: null,
            };
            this.getSubscriptionPlans(body);
        }
    },
};
</script>

<style lang="scss">
.sp-container {
    height: 100%;
    padding: 0;
    padding-bottom: 30px;
    background-color: #f5f5fd;
    font-family: "'MULI'", "helvetica", "Arial";

    .sp-container__content {
        margin-top: 6%;

        .sp-container__subtitle {
            font-size: 24px;
            font-weight: bolder;
        }

        .sp-container__card {
            background: linear-gradient(
                179.11deg,
                #2a3042 -23.36%,
                #0d1748 58.69%
            );
            color: white;
            border: 8px;
        }

        .card__price-box {
            font-size: 35px;

            .card__price {
                font-size: 50px;
            }
        }

        .card__subtitle {
            color: gray;
            font-size: 17px;
        }

        .card__description {
            font-size: 15px;
        }

        .card__list-item {
            font-size: 16px;
            letter-spacing: 1px;
        }

        .blue-text {
            color: #2255fe;
        }

        .green-text {
            color: green;
        }

        .red-text {
            color: red;
        }

        .card__btn {
            color: white;
            text-transform: inherit !important;
            letter-spacing: 1px;
            padding: 20px 0px;
            border-radius: 10px;
        }
    }
}
</style>